// ID↔BV design loop API (arch-freelancer parity): one flat lead + deliverables[], and a
// small set of intent-named actions. axiosInstance returns response.data directly.
import axiosInstance from "../api/axios";

// --- Read: the single detail payload (flat lead + ordered deliverables) ---
export const getDesignLead = (idLeadId) =>
  axiosInstance.get(`/interior-designers/leads/${idLeadId}/detail`);

export const listDeliverables = (params = {}) =>
  axiosInstance.get(`/interior-designers/design-deliverables`, { params });

// --- Designer actions ---
export const acknowledgeLead = (idLeadId) =>
  axiosInstance.post(`/interior-designers/leads/${idLeadId}/acknowledge`);

export const cancelLead = (idLeadId) =>
  axiosInstance.post(`/interior-designers/leads/${idLeadId}/cancel`);

/** payload: { iterationName?, estimatedPrice, media, designerNotes?, isFinal } */
export const submitDesign = (idLeadId, payload) =>
  axiosInstance.post(`/interior-designers/leads/${idLeadId}/design`, payload);

export const acknowledgeFeedback = (idLeadId) =>
  axiosInstance.post(`/interior-designers/leads/${idLeadId}/design/acknowledge-feedback`);

// --- Reviewer (buyer / BV) actions ---
/** action: "REQUEST_CHANGES" | "APPROVE"; feedback required for REQUEST_CHANGES */
export const reviewDesign = (idLeadId, action, feedback = null, feedbackMedia = null) =>
  axiosInstance.post(`/interior-designers/leads/${idLeadId}/design/review`, {
    action,
    feedback,
    feedbackMedia,
  });

// --- Developer decision ---
export const developerReview = (idLeadId, approve, notes = null) =>
  axiosInstance.post(`/interior-designers/leads/${idLeadId}/design/developer-review`, {
    approve,
    notes,
  });

export const listPendingDeveloperApproval = (params = {}) =>
  axiosInstance.get(`/interior-designers/design-deliverables/pending-approval`, { params });

export const listPastDeveloperApproval = (params = {}) =>
  axiosInstance.get(`/interior-designers/design-deliverables/past-approved`, { params });
